import React, { useMemo } from 'react';
import { View, Text } from 'react-native';
import theme from '../../../common/theme';
import { styles } from './NetworkDeviceRow.styles';
import Icon from '../../Icon/Icon';
import Badge from './Badge';

interface Props {
  name: string;
  lastSeen: string;
  ipAddress: string;
  isAvailableInLocalNetwork: boolean;
  isCurrentDevice: boolean;
  hasInternetConnection: boolean | null;
  isCDSDevice: boolean;
}

const NetworkDeviceRow: React.FC<Props> = ({
  name,
  lastSeen,
  ipAddress,
  isAvailableInLocalNetwork = false,
  hasInternetConnection = false,
  isCurrentDevice = false,
  isCDSDevice = false,
}) => {
  const statusStyles = useMemo(() => {
    if (isAvailableInLocalNetwork === true) {
      return {
        icon: 'check-circle',
        iconColor: theme.palette.green,
        rowStyle: undefined,
      };
    } else if (!isAvailableInLocalNetwork && !hasInternetConnection) {
      return {
        icon: 'exclamation-triangle',
        iconColor: theme.palette.red,
        rowStyle: styles.rowDeviceError,
      };
    }
    return {
      icon: 'exclamation-triangle',
      iconColor: theme.palette.orange,
      rowStyle: styles.rowDeviceWarning,
    };
  }, [hasInternetConnection, isAvailableInLocalNetwork]);

  const displayName = `${name}${isCurrentDevice ? ' (This Device)' : ''}`;

  return (
    <View style={[styles.rowDevice, statusStyles.rowStyle]}>
      <View style={styles.text}>
        <Text style={styles.name}>{displayName}</Text>
        <Text style={styles.subtext}>{ipAddress}</Text>
        <Text style={styles.subtext}>{`Last seen: ${lastSeen}`}</Text>
      </View>
      {isCDSDevice && <Badge label="CDS" />}
      <Icon name={statusStyles.icon} color={statusStyles.iconColor} />
    </View>
  );
};

export default NetworkDeviceRow;
